module.exports = __webpack_public_path__ + "img/certificadoM5.879cff11.png";